var map = {
	"./alfajores/HEOPriceOracle": [
		1221,
		19
	],
	"./aurora/HEOPriceOracle": [
		1222,
		22
	],
	"./auroratest/HEOPriceOracle": [
		1223,
		25
	],
	"./bsc/HEOPriceOracle": [
		1224,
		29
	],
	"./bscdev/HEOPriceOracle": [
		1232,
		34
	],
	"./bsctest/HEOPriceOracle": [
		1225,
		38
	],
	"./celo/HEOPriceOracle": [
		1226,
		42
	],
	"./ganache/HEOPriceOracle": [
		1227,
		45
	],
	"./goerli/HEOPriceOracle": [
		1228,
		48
	],
	"./rinkeby/HEOPriceOracle": [
		1229,
		51
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 512;
module.exports = webpackAsyncContext;